<div class="country-selector" [ngClass]="styleClass">
    <button
        type="button"
        class="country-selector-btn"
        [class.country-selector-btn-header]="variant === 'header'"
        [class.country-selector-btn-menu]="variant === 'menu'"
        (click)="toggleDropdown()"
    >
        <span class="country-code">{{
            selectedCountry?.code || 'BHR'
        }}</span>
        <svg
            class="arrow-icon"
            width="7"
            height="5"
            viewBox="0 0 7 5"
            fill="none"
        >
            <path
                d="M0.5 0.5L3.5 3.5L6.5 0.5"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>

    <div
        class="country-dropdown"
        *ngIf="isOpen"
        [class.country-dropdown-menu]="variant === 'menu'"
    >
        <div class="country-dropdown-content">
            <button
                *ngFor="let country of countries"
                type="button"
                class="country-item"
                [class.country-item-rtl]="isArabic"
                [class.active]="selectedCountry?.code === country.code"
                (click)="selectCountry(country)"
            >
                <span class="country-name">{{
                    translateHelper.localize(country.name)
                }}</span>
                <span class="country-code-small">{{
                    country.code
                }}</span>
            </button>
            <div
                *ngIf="!countries || countries.length === 0"
                class="country-item-empty"
            >
                {{ 'no_countries_available' | translate }}
            </div>
        </div>
    </div>
</div>

<div
    class="country-backdrop"
    *ngIf="isOpen"
    (click)="closeDropdown()"
></div>

<app-confirmation-dialog
    [isOpen]="showConfirmDialog"
    [title]="'change_country' | translate"
    [message]="'change_country_clear_cart_message' | translate"
    [confirmText]="'proceed' | translate"
    [cancelText]="'cancel' | translate"
    (confirm)="onConfirmCountryChange()"
    (cancel)="onCancelCountryChange()"
></app-confirmation-dialog>
